import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import { WidgetPlaceholder } from './WidgetPlaceholder';
export function MinimizedWidgets() {
    const overlay = Common.useOverlay();
    return (_jsx(Components.FrameSegment, { children: _jsxs(Components.BtnGroup, { children: [_jsx(WidgetPlaceholder, { type: Common.WidgetPlaceholderType.Docked, name: Common.MINIMIZED_WIDGETS_PLACEHOLDER }), _jsx(Components.Button, { onClick: () => overlay.setOverlay({
                        type: Common.OverlayType.FrameRegister,
                    }), children: "+" })] }) }));
}
